import React from "react";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";
import Layout from "../../components/layout";
import Monitoring from "../../components/monitoring";
import * as monitoringActions from "../../actions/monitoring";
import { MonitoringDTO } from "../../../types/Monitoring";

interface Props {
  issuedMonitoring: MonitoringDTO[];
  cancelledMonitoring: MonitoringDTO[];
  gettingIssuedMonitoring: boolean;
  gettingCancelledMonitoring: boolean;
  getIssuedInvoicesMonitoring: (year: number) => void;
  getCancelledInvoicesMonitoring: (year: number) => void;
}

/**
 * Contenedor de METADATA SAT; conecta los calendarios con Redux.
 */
class MonitoringContainer extends React.Component<Props> {
  render() {
    return (
      <main>
        <Helmet title="METADATA SAT" />
        <Layout>
          <Monitoring
            issuedMonitoring={this.props.issuedMonitoring}
            cancelledMonitoring={this.props.cancelledMonitoring}
            gettingIssuedMonitoring={this.props.gettingIssuedMonitoring}
            gettingCancelledMonitoring={this.props.gettingCancelledMonitoring}
            getIssuedInvoicesMonitoring={this.props.getIssuedInvoicesMonitoring}
            getCancelledInvoicesMonitoring={
              this.props.getCancelledInvoicesMonitoring
            }
          />
        </Layout>
      </main>
    );
  }
}

const mapStateToProps = state => {
  const { monitoring } = state;
  return {
    issuedMonitoring: (monitoring && monitoring.issuedMonitoring) || [],
    cancelledMonitoring: (monitoring && monitoring.cancelledMonitoring) || [],
    gettingIssuedMonitoring:
      (monitoring && monitoring.gettingIssuedMonitoring) || false,
    gettingCancelledMonitoring:
      (monitoring && monitoring.gettingCancelledMonitoring) || false
  };
};

const mapDispatchToProps = dispatch => ({
  getIssuedInvoicesMonitoring: (year: number) => {
    dispatch(monitoringActions.getIssuedInvoicesMonitoring(year));
  },
  getCancelledInvoicesMonitoring: (year: number) => {
    dispatch(monitoringActions.getCancelledInvoicesMonitoring(year));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MonitoringContainer);
